import { IRecruiterTeamNameAutoCompleteOption } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import {
  getOnDemandWorkspaceMemberAutocompleteOptions,
  transformIRecruiterTeamNameOptionsToStringArray,
} from '../../../features/jobs/helper';
import WsFilterProps from '../models/WsFilterProps';

const WsWorkspaceUserFilter = ({
  name,
  multiple = false,
  placeHolder = 'Please enter user name or email',
  focused,
}: WsFilterProps) => {
  const onUserInputKey = async (input: string) => {
    const result: IRecruiterTeamNameAutoCompleteOption[] =
      await getOnDemandWorkspaceMemberAutocompleteOptions(input);
    if (result.length > 0) {
      const usersNames: string[] = transformIRecruiterTeamNameOptionsToStringArray(result);
      return usersNames;
    }
    return [];
  };

  return (
    <WsAutocompleteInput
      getOptions={onUserInputKey}
      options={[]}
      placeholder={placeHolder}
      multiple={multiple}
      freeSolo={false}
      name={name}
      size="small"
      focused={focused}
    />
  );
};

export default WsWorkspaceUserFilter;
